/**
 * Billing redirect — notification actionUrls link to /billing;
 * the actual UI lives in Settings > Plan & Billing.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { section: 'billing' } });
  },
  component: () => null,
});
